const Suitcase = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-suitcase"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-suitcase"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M19,4h-1.101c-.465-2.279-2.485-4-4.899-4h-2c-2.414,0-4.435,1.721-4.899,4h-1.101C2.243,4,0,6.243,0,9v10c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V9c0-2.757-2.243-5-5-5ZM11,2h2c1.304,0,2.415,.836,2.828,2h-7.656c.413-1.164,1.524-2,2.828-2Zm11,17c0,1.654-1.346,3-3,3h-1V9c0-.553-.447-1-1-1s-1,.447-1,1v13H8V9c0-.553-.448-1-1-1s-1,.447-1,1v13h-1c-1.654,0-3-1.346-3-3V9c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3v10Z" />
    </svg>
  );
};

export default Suitcase;
